/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CtmsItemUpdateReqVo
 */
export interface CtmsItemUpdateReqVo {
    /**
     * 通关项目分类id
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    ctmsCategoryId: number;
    /**
     * HS 编码
     * @type {string}
     * @memberof CtmsItemUpdateReqVo
     */
    hsCode: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof CtmsItemUpdateReqVo
     */
    itemName: string;
    /**
     * 商品名称（英文）
     * @type {string}
     * @memberof CtmsItemUpdateReqVo
     */
    itemNameEn: string;
    /**
     * 商品名称（中文）
     * @type {string}
     * @memberof CtmsItemUpdateReqVo
     */
    itemNameCn: string;
    /**
     * 关税税率
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    taxRate: number;
    /**
     * 增值税税率
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    vatRate: number;
    /**
     * 是否列表通关  0 不是， 1 是
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    list: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    enable: number;
    /**
     * 是否需要kc认证，0 不需要， 1 需要
     * @type {number}
     * @memberof CtmsItemUpdateReqVo
     */
    kcCertification?: number;
}

/**
 * Check if a given object implements the CtmsItemUpdateReqVo interface.
 */
export function instanceOfCtmsItemUpdateReqVo(value: object): value is CtmsItemUpdateReqVo {
    if (!('ctmsCategoryId' in value) || value['ctmsCategoryId'] === undefined) return false;
    if (!('hsCode' in value) || value['hsCode'] === undefined) return false;
    if (!('itemName' in value) || value['itemName'] === undefined) return false;
    if (!('itemNameEn' in value) || value['itemNameEn'] === undefined) return false;
    if (!('itemNameCn' in value) || value['itemNameCn'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('vatRate' in value) || value['vatRate'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function CtmsItemUpdateReqVoFromJSON(json: any): CtmsItemUpdateReqVo {
    return CtmsItemUpdateReqVoFromJSONTyped(json, false);
}

export function CtmsItemUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CtmsItemUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ctmsCategoryId': json['ctmsCategoryId'],
        'hsCode': json['hsCode'],
        'itemName': json['itemName'],
        'itemNameEn': json['itemNameEn'],
        'itemNameCn': json['itemNameCn'],
        'taxRate': json['taxRate'],
        'vatRate': json['vatRate'],
        'list': json['list'],
        'enable': json['enable'],
        'kcCertification': json['kcCertification'] == null ? undefined : json['kcCertification'],
    };
}

export function CtmsItemUpdateReqVoToJSON(json: any): CtmsItemUpdateReqVo {
    return CtmsItemUpdateReqVoToJSONTyped(json, false);
}

export function CtmsItemUpdateReqVoToJSONTyped(value?: CtmsItemUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ctmsCategoryId': value['ctmsCategoryId'],
        'hsCode': value['hsCode'],
        'itemName': value['itemName'],
        'itemNameEn': value['itemNameEn'],
        'itemNameCn': value['itemNameCn'],
        'taxRate': value['taxRate'],
        'vatRate': value['vatRate'],
        'list': value['list'],
        'enable': value['enable'],
        'kcCertification': value['kcCertification'],
    };
}

